export const loginMFALoaderConfig = {
  loginMFA: {
    text: 'loading_MFA.validate_text',
    icon: 'assets/images/logo-ivnosys-loading.png'
  } as const
}
